<template lang="pug">
  section(:class="css")
    h1.font-blau.leading-none.text-68.md-text-8vw.xl-text-100.text-center.break-all.p-2(v-html="row.title")
    //- Maos caption
    //- h6(v-if="isMaos").absolute.bottom-0.left-0.p-40.text-24.leading-none.font-unica Phonetic, colours, textures, light, sounds
</template>

<script>
export default {
  name: 'BlauTitle',
  props: ['row', 'index'],
  computed: {
    isMaos () {
      return this.$route.params.slug === 'maos'
    },
    css () {
      const i = this.index
      return this.isMaos && i === 0
        // Maos
        ? ['relative blau-title--maos bg-brown pt-120 min-h-screen mb-100']
        // default
        : ['mb-120', i > 0 ? 'mt-120' : 'mt-53']
    }
  }
}
</script>
